/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { healthControllerPing } from '../fn/health/health-controller-ping';
import { HealthControllerPing$Params } from '../fn/health/health-controller-ping';
import { HealthResponseDto } from '../models/health-response-dto';

@Injectable({ providedIn: 'root' })
export class HealthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `healthControllerPing()` */
  static readonly HealthControllerPingPath = '/health/ping';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `healthControllerPing()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthControllerPing$Response(params?: HealthControllerPing$Params, context?: HttpContext): Observable<StrictHttpResponse<HealthResponseDto>> {
    return healthControllerPing(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `healthControllerPing$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthControllerPing(params?: HealthControllerPing$Params, context?: HttpContext): Observable<HealthResponseDto> {
    return this.healthControllerPing$Response(params, context).pipe(
      map((r: StrictHttpResponse<HealthResponseDto>): HealthResponseDto => r.body)
    );
  }

}
